import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import DevExDataTable from './DevExDataTable';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import {crudService} from '../../Services/crudService';
import DeleteDialog from './DeleteDialog';
import { toast } from 'react-toastify';

export default function CrudTable(props) {
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(0);

    const booleanColumns = props.columns.filter(col => col.dataType === 'bit');
    let booleanColumnsArray = booleanColumns.map(a => a.name);

    const ActionFormatter = (row) => (
        <React.Fragment>
            <IconButton onClick={() => editRow(row.row.id)} title="Edit row">
            <EditIcon />
            </IconButton>
            <IconButton onClick={() => deleteRow(row.row.id)}>
                <DeleteIcon />
            </IconButton>
        </React.Fragment>
    );

    const BooleanFormatter = (row) => (
        <React.Fragment>
            {row.value.toString()}
        </React.Fragment>
    );

    const editRow = (id) => {
        props.openDrawer("Edit", true, id);
    };

    const deleteRow = (id) => {
        setDeleteId(id);
        setOpenDeleteDialog(true);
    };

    const handleClose = () => {
        setOpenDeleteDialog(false);
    };

    const handleDelete = (id) => {
        setOpenDeleteDialog(false);
        crudService.deleteTableRow(props.crud.schemeName, props.crud.api, props.user.userToken, id).catch((error) => {
            toast.error(error, {
              position: toast.POSITION.TOP_CENTER
            });
          });
    };

    const classes = useStyles();
    return <React.Fragment>
                <DevExDataTable classname={classes.table} hasActions={true} booleanColumns={booleanColumnsArray} BooleanFormatter={BooleanFormatter} ActionFormatter={ActionFormatter} columns={props.columns} data={props.rows} editRow={editRow} deleteRow={deleteRow} ></DevExDataTable>
                <DeleteDialog open={openDeleteDialog} table={props.crud.table} id={deleteId} handleClose={handleClose} handleDelete={handleDelete}></DeleteDialog>
            </React.Fragment>
    
            
}

const useStyles = makeStyles({
    table: {
        height: '100%'  
      }
});